import { useEffect, useState } from 'react';

import { ReferenceLine, LineChart, Line, XAxis, YAxis, CartesianGrid, Tooltip, ResponsiveContainer } from 'recharts';

import { servGetGraficoDetalhamentoMetrica, servGetGraficoDetalhamentoEstabelecimento } from '../../../servicos/graficos_indicador';
import { servGetMetricaByEstabelecimento } from '../../../servicos/metrica_estabelecimento';
import { servGetmetricas } from '../../../servicos/metrica';
import { extraiNumeroMeta, formataOperadoresRelacionaisMetrica } from '../../../util/utilitarios';

// import Chart from "react-apexcharts";

function LineChartDetalhamentoIndicador({ dadosGraf, estabelecimento }) {

    console.log('### Iniciando LineChartDetalhamentoIndicadorOuEstabelecimento ###');

    const CustomTooltip = ({ payload, label, active, meta }) => {
        if (active && payload && payload.length) {
            return (
                <div style={{ background: "#fff", border: "1px solid #ccc", padding: 8 }}>
                    <p>{`Mês: ${label}`}</p>
                    <p>{`Resultado: ${payload[0].value}`}</p>
                    <p>{`Meta: ${meta}`}</p>
                </div>
            );
        }
        return null;
    };

    return (
        <div className='p-3'>
            <div className='text-center mt-3'>
                {estabelecimento && <p>Unidade Selecionada: <strong>{estabelecimento.nome}</strong></p>}
            </div>
            <div className='d-flex flex-column flex-md-row row justify-content-center'>
                {dadosGraf && (

                    dadosGraf.map((metrica) => {
                        const metricaNumerico = extraiNumeroMeta(metrica.metricaMeta)
                        return (
                            <div key={metrica.metricaId} className='col-12 col-sm-4 div-com-borda' style={{ 'height': '40em' }}>
                                <div className='d-flex justify-content-center align-items-center text-center' style={{ 'height': '15%' }}>
                                    <p className='m-0'>{metrica.metricaCodigo} - {metrica.metricaDescricao}</p>
                                </div>
                                <ResponsiveContainer width='90%' height='75%'>
                                    <LineChart data={metrica.indicadores} >
                                        <CartesianGrid strokeDasharray="4 4" />
                                        <XAxis dataKey="mesReferencia" />
                                        {/* A ideia desse código todo abaixo é que o numero máximo dos gráficos sejam sempre múltiplos de 5 */}
                                        <YAxis domain={[0, dataMax => Math.ceil(dataMax / 5) * 5 + 10]} />
                                        <Tooltip content={<CustomTooltip meta={formataOperadoresRelacionaisMetrica(metrica.metricaMeta)} />} />

                                        <ReferenceLine
                                            y={metricaNumerico}
                                            stroke="#dc3545"
                                            ifOverflow="visible"
                                            strokeDasharray="4 4"
                                        />

                                        <Line type="monotone"
                                            dot={false}
                                            dataKey="resultado"
                                            stroke="#0088FE"
                                            label={{ fontSize: 14 }}
                                        />
                                    </LineChart>
                                </ResponsiveContainer>
                                <div className='align-items-center text-center'>
                                    <p className='m-0' style={{ 'fontSize': '0.8em' }}>Fonte: {metrica.metricaFonte}</p>
                                </div>
                            </div>
                        )
                    })
                )
                }
            </div>
        </div>
    )
}

export default LineChartDetalhamentoIndicador

